<!-- Converter hero: swatch + editable hex (left), the conversion result (right). -->
<div class="cp-hero">
  <!-- Left: a square color swatch (click to open the native picker) with the
       editable hex centered below it. Identical to the color widget. -->
  <div class="cp-hero-color-col">
    <div class="cp-hero-square" [style.background-color]="current">
      <input type="color" [ngModel]="current" (ngModelChange)="onColorChange( $event )"
             class="cp-hero-picker" aria-label="Pick a color"/>
      <span class="cp-hero-pick-hint" aria-hidden="true">Select</span>
    </div>
    <div class="cp-hero-hexbar" *ngIf="!reverse">
      <!-- The notation title sits above the bare input: no name or parentheses
           inside the field itself, on every converter alike. -->
      <span class="cp-hero-input-title">{{ fromLabel }}</span>
      <label class="hex-field">
        <span class="hex-hash">#</span>
        <input type="text" class="hex-input"
               [ngModel]="hexText"
               (ngModelChange)="onHexTextChange( $event )"
               (keydown)="onHexKeydown( $event )"
               (keydown.enter)="onHexEnter( $event )"
               (focus)="onHexFocus( $event )"
               (blur)="hexText = current.substring( 1 ).toLowerCase()"
               maxlength="6"
               inputmode="latin"
               spellcheck="false"
               autocomplete="off"
               autocapitalize="off"
               aria-label="Hex color code"/>
      </label>
    </div>

    <!-- Reverse direction: the editable field is the three channels of the
         source notation (rgb or hsl). -->
    <div class="cp-hero-hexbar" *ngIf="reverse">
      <!-- The notation title sits above the bare channel inputs: no name,
           parentheses or commas inside the field, on every family alike. -->
      <span class="cp-hero-input-title">{{ fromLabel }}</span>
      <span class="hex-field rgb-field" [class.oklab-field]="family === 'oklab' || family === 'lab' || decimalFamily">
        <ng-container *ngFor="let label of channelLabels; let i = index">
          <!-- Comma between channels for every comma family incl. cmyk; hwb(),
               oklch() and oklab() are space-separated (per CSS). -->
          <span class="hex-hash" *ngIf="i > 0 && family !== 'hwb' && family !== 'oklch' && family !== 'oklab' && family !== 'lab' && family !== 'lch' && family !== 'p3'">,</span>
          <input type="text" class="hex-input rgb-input"
                 [ngModel]="channelTexts[ i ]"
                 (ngModelChange)="onChannelTextChange( i, $event )"
                 (keydown)="onChannelKeydown( $event )"
                 (keydown.enter)="onHexEnter( $event )"
                 (blur)="onChannelBlur()"
                 [attr.maxlength]="( ( family === 'oklab' || family === 'lab' ) && i > 0 ) || decimalFamily ? 8 : 3"
                 [attr.inputmode]="( ( family === 'oklab' || family === 'lab' ) && i > 0 ) || decimalFamily ? 'text' : 'numeric'"
                 spellcheck="false"
                 autocomplete="off"
                 [attr.aria-label]="label + ' channel value'"/>
          <!-- Percent dressing: hue-led families skip the first (hue) field; every
               CMYK field is a percent; OKLCH/OKLAB mark only their first (Lightness) field. -->
          <span class="hex-hash" *ngIf="family === 'cmyk' || ( family !== 'rgb' && !decimalFamily && family !== 'oklch' && family !== 'oklab' && family !== 'lab' && family !== 'lch' && i > 0 ) || ( family === 'oklch' && i === 0 ) || ( family === 'lch' && i === 0 ) || ( ( family === 'oklab' || family === 'lab' ) && i === 0 )">%</span>
        </ng-container>
      </span>
    </div>
  </div>

  <!-- Right: the conversion output. Direction eyebrow, the big result value with
       a copy button, and the channels as tinted bars. -->
  <div class="cp-hero-out">
    <span class="cp-hero-eyebrow">{{ fromLabel }} <span class="cp-hero-arrow" aria-hidden="true">&rarr;</span> {{ toLabel }}</span>

    <div class="cp-hero-result">
      <!-- the value written out, an arrow, the result, then Copy (owner 2026-10-12) -->
      <span class="cp-hero-from">{{ inString }}</span>
      <span class="cp-hero-to-arrow" aria-hidden="true">&rarr;</span>
      <span class="cp-hero-value">{{ outString }}</span>
      <button type="button" class="cp-hero-copy" (click)="copy( outString, 'out' )" [attr.aria-label]="'Copy ' + toLabel">
        <app-icon name="copy" aria-hidden="true"></app-icon>{{ copiedKey === 'out' ? 'Copied' : 'Copy' }}
      </button>
    </div>

    <div class="cp-hero-channels">
      <div class="cp-hero-ch" *ngFor="let c of channels">
        <span class="cp-hero-ch-label">{{ c.label }}</span>
        <span class="cp-hero-ch-track" [style.background]="c.track">
          <span class="cp-hero-ch-fill" [style.width.%]="c.value / c.max * 100" [style.background]="c.tint"></span>
        </span>
        <span class="cp-hero-ch-val">{{ c.display }}</span>
      </div>
    </div>
  </div>
</div>
